<template>
  <b-row align-v="center" class="ma-1 ml-0 pl-0">
    <b-col cols="auto" class="d-flex align-items-center mr-0 pr-0 ml-0 pl-0">
      <!-- uchwyt do drag -->
      <i
        class="fa fa-th mr-2 cursor-move text-muted"
        style="font-size: 20px; margin-bottom: -8px !important;"
      ></i>
      <!-- podgląd typu odpowiedzi -->
      <input
        v-if="questionType === 2"
        type="radio"
        disabled
        class="mr-0 pr-0 form-control"
        style="margin-bottom: -8px !important;"
      />
      <input
        v-else-if="questionType === 3"
        type="checkbox"
        disabled
        class="p-0 m-0 form-control"
        style="margin-bottom: -8px !important;"
      />
    </b-col>
    <b-col md="8" sm="5" class="ml-0 pl-2">
      <b-form-input
        class="pb-1 pl-0 ml-0"
        v-model="surveysQuestionsAnswer.answerDescription"
      />
    </b-col>
    <b-col cols="auto">
      <b-button
        variant="link"
        class="ml-0 p-0 text-danger"
        @click="removeItemCollection(answerKey, 'surveysQuestionsAnswer')"
        v-b-tooltip.hover
        :title="$t('buttons.delete')"
      >
        <i class="fa fa-trash"></i>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'surveysQuestionsAnswers',
  props: {
    surveysQuestionsAnswer: {
      type: Object,
      required: true
    },
    questionType: {
      type: Number,
      required: true
    },
    answerKey: {
      type: Number,
      required: true
    },
    removeItemCollection: {
      type: Function,
      required: true
    }
  }
}
</script>
